import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";
import Home from "pages/home";
// import ToggleLang from "components/language-toggle";
import Page404 from "pages/error/404";
import "./style.scss";
import { AuthConfigContext } from "context/AuthConfigProvider";
import ProfileRouter from "pages/profile/ProfileRouter"
import PointsRouter from "pages/points/PointsRouter";
import Warranty from "pages/warranty";
import OrderHistory from "pages/order";
import Agreement from "pages/agreement";
import EcommerceRouter from "pages/ecommerce/EcommerceRouter";

const PageContent = () => {
  const authConfig = useContext(AuthConfigContext);
  const services = authConfig.configJson.services;
  return (
    <div className="main-content">
      {/* <ToggleLang /> */}

      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/home" component={Home} />
        {services && services.map((route, i) => {
          switch (route.name) {
            case "Profile":
              return (
                <Route path={route.link} component={ProfileRouter} key={i} />
              )
            case "Points":
              return (
                <Route path={route.link} component={PointsRouter} key={i} />
              )
            case "Warranty":
              return (
                <Route path={route.link} component={Warranty} key={i} />
              )
            case "Ecommerce":
              return (
                <Route path={route.link} component={EcommerceRouter} key={i} />
              )
            case "Order":
              return (
                <Route path={route.link} component={OrderHistory} key={i} />
              )
            case "Agreement":
              return (
                <Route path={route.link} component={Agreement} key={i} />
              )
            default :
            return (
              <Route exact path="/home" component={Home} />
            )
          }
        })}
        <Route path={'/ecommerce'} component={EcommerceRouter} />
        <Route component={Page404} />
      </Switch>
    </div>
  );
};

export default PageContent;
